export default __webpack_public_path__ + "static/media/outdoor-seating.4890bea9.jpg";